<template lang="pug">
  svg(width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg")
    path(
      d=`
        M0 10.5C0 4.97715 4.47715 0.5 10 0.5H30C35.5228 0.5 40 4.97715
        40 10.5V30.5C40 36.0228 35.5228 40.5 30 40.5H10C4.47715 40.5 0 36.0228 0 30.5V10.5Z
      ` fill="#8783D1")
    path(
      d=`
        M35 10.5C35 12.7091 33.2091 14.5 31 14.5C28.7909 14.5 27 12.7091
        27 10.5C27 8.29086 28.7909 6.5 31 6.5C33.2091 6.5 35 8.29086 35 10.5Z
      ` fill="#FFBE0B"
    )
    path(
      d=`
        M5.17916 35.5C4.79277 35.5 4.49964 35.3787 4.29979 35.136C4.09993 34.8799
        4 34.6642 4 34.4889C4 34.3002 4.01999 34.1519 4.05996 34.044L14.1527 6.58284C14.6058
        5.38302 15.3319 4.70896 16.3312 4.56067C16.6776 4.52022 17.0907 4.5 17.5703 4.5H17.9101C18.8161
        4.5 19.4423 4.61459 19.7887 4.84377C20.3483 5.19428 20.7813 5.75375 21.0878 6.52218L31.94\
        34.0643C31.98 34.1721 32 34.3271 32 34.5294C32 34.7181 31.9201 34.9271 31.7602
        35.1562C31.6003 35.3854 31.3338 35.5 30.9607 35.5H28.1627C27.5498 35.5 27.1235
        35.2102 26.8837 34.6305L24.4054 28.0584H11.2748L8.97645 34.6305C8.78991 35.2102
        8.38354 35.5 7.75732 35.5H5.17916ZM22.7266 23.6905L17.95 10.5463C17.9101 10.4115
        17.8301 10.3441 17.7102 10.3441C17.5903 10.3441 17.5104 10.4115 17.4704 10.5463L12.8337 23.6905H22.7266Z
      ` fill="white")
    path(
      d=`
        M29.3976 31.9071L29.4147 31.3454C29.4262 30.993 29.4605 30.6076 29.5177 30.1891L29.655
        29.2145C29.6836 28.9832 29.7122 28.7739 29.7408 28.5867C29.1974 29.1594 28.7597 29.6054
        28.428 29.9248L27.4412 30.8499C25.2331 32.8377 23.9174 33.8316 23.4941 33.8316C22.8706
        33.8316 22.2156 33.7022 21.5291 33.4434C21.1573 33.3002 20.9457 33.1515 20.8942
        32.9973C20.8141 32.8046 20.774 32.5431 20.774 32.2127C20.774 31.8768 20.7855 31.5684
        20.8084 31.2876C20.8312 31.0068 20.8598 30.7287 20.8942 30.4534C20.9285 30.1726
        20.9628 29.9055 20.9971 29.6522C21.0372 29.3934 21.0686 29.1677 21.0915 28.9749C21.1487
        28.5399 21.1602 28.3224 21.1258 28.3224L17.9339 32.097C16.4294 33.7985 15.5742 34.7401
        15.3683 34.9218C14.9278 35.3073 14.4415 35.5 13.9095 35.5C13.6464 35.5 13.429 35.4367 13.2574
        35.31C13.0858 35.1834 13 35.0265 13 34.8392C13 34.4648 13.163 34.0738 13.4891 33.6664L21.1087
        24.3413L22.0011 23.3088C23.0651 22.1029 23.763 21.5 24.0947 21.5C24.5581 21.5 24.9986
        21.6129 25.4162 21.8386C25.788 22.0369 25.9996 22.2296 26.0511 22.4168C26.074 22.4884
        26.0254 22.8215 25.9053 23.4162L25.6049 24.9773C25.2674 26.7173 25.0987 27.8406 25.0987
        28.3472C25.0987 28.8483 25.1587 29.0988 25.2789 29.0988C25.6679 29.0988 26.4172 28.4849
        27.527 27.2569L30.3071 24.0522C30.9192 23.3749 31.3253 22.9895 31.5256 22.8959C31.5828
        22.8683 31.6657 22.8546 31.7744 22.8546C31.8831 22.8546 32.0032 22.8683 32.1348
        22.8959C32.2721 22.9234 32.4094 22.9592 32.5467 23.0032C32.6897 23.0473 32.827 23.0996
        32.9585 23.1602C33.0901 23.2207 33.2074 23.2841 33.3103 23.3501C33.5334 23.4933 33.6421
        23.6117 33.6364 23.7053C33.6364 23.7934 33.6135 23.9889 33.5677 24.2917C33.522 24.5891
        33.4648 24.9525 33.3961 25.382C32.9213 28.2288 32.6725 29.8807 32.6496 30.3378C32.6325
        30.7948 32.6811 31.0811 32.7955 31.1968C32.9156 31.3124 33.0901 31.3702 33.3189
        31.3702C33.7365 31.3702 34.3429 31.1307 35.138 30.6516C35.6757 30.3267 36.1191 30.1643
        36.468 30.1643C36.8227 30.1643 37 30.3267 37 30.6516C37 30.9875 36.8112 31.395 36.4337
        31.874C35.8902 32.5678 35.0779 33.1956 33.9968 33.7572C33.0872 34.2253 32.2235 34.4593
        31.4054 34.4593C30.0669 34.4593 29.3976 33.6086 29.3976 31.9071Z
      ` fill="#5542AF"
    )
</template>

<script>
export default {
};
</script>
